<template>
  <modal v-if="show || loading" force xsmall class="save loader-fancy">
    <div slot="body">
      <div class="p-5 text-center">
        <ul class="list list-unstyled text-left  mb-0">
          <li v-for="(item, key) in status" :key="key">
            <span :style="{ 'opacity' : !item.active ? '0.7' : '1'}">
              <i class="icon-check_circle" :style="{ 'color' : !item.active ? '#666' : '#f6ab2f' }"></i>
              {{ item.text }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </modal>
</template>

<script>
import { Modal } from "@/components";

export default {
  name: "steps-loader",
  components: { Modal },
  props: { 
    loading: { default: false, },
  },
  watch: {
    loading(value) {
      if(value === true) this.init()
    }
  },
  data() {
    return {
      status: [],
      count: 0,
      show: false,
    }
  },
  mounted() {
    if(this.loading) this.init()
  },
  methods: {
    init() {
      this.status = [
        { text: this.$t('loader.bullet_1'), active: false },
        { text: this.$t('loader.bullet_2'), active: false },
        { text: this.$t('loader.bullet_3'), active: false },
        { text: this.$t('loader.bullet_4'), active: false }
      ]
      this.count = 0;
      this.show = true;
      this.setActive();
    },
    setActive() {
      let rand = Math.floor(Math.random() * (500 - 300 + 1)) + 300;

      setTimeout(() => {
        if(this.count < this.status.length) this.status[this.count].active = true;
        this.count <= this.status.length ? this.setActive() : this.show = false;
        this.count++;
      }, rand);
    }
  }
};
</script>